module.exports = __webpack_public_path__ + "img/L_322_0.b8faca3a.png";